import { IkeDraw } from '../draw';

export interface AcceptEvent {
	drawableId: string;
	$event: Event;
}

export function drawableAcceptBinding(dc: IkeDraw, evt: AcceptEvent) {
	const drawableId = dc.state.selectedId;
	if (drawableId == null) {
		return;
	}
	if (evt.$event != null) {
		evt.$event.preventDefault();
	}

	const drawable = dc.selected;
	if (drawable == null) {
		return;
	}

	if (!drawable.isApprovableInsightDrawable()) {
		return;
	}

	drawable.approveInsightFlag();
}
